import '@/common/promiseExtend'

import Vue from 'vue'
import VueRx from 'vue-rx'
import Rx from 'rxjs/Rx'
import ElementUI from 'element-ui'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './locales'
import SvgIcon from '@/components/SvgIcon.vue'
import permission from '@/directive/permission'
import { get as getToken } from '@/common/token'
import { MutationsTypes, ActionsType } from '@/store/modules/user'
import { isDefaultTheme, getTheme } from "./common/theme/index";
import { updateElementTheme } from "./common/theme/operator";
import { EventBus } from './common/eventBus/base'
import { ResizeWindowEventName } from "./common/eventBus/resizeEventBus";
import { debounce } from 'lodash'
import { parse, getSessionID } from "./common/token";
import vcolorpicker from 'vcolorpicker'
import { codemirror } from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/dracula.css';



Vue.config.productionTip = false
Vue.use(VueRx, Rx)
Vue.use(vcolorpicker)
Vue.use(codemirror)
Vue.use(ElementUI, { size: 'small', zIndex: 3000 })
Vue.component('svg-icon', SvgIcon)
Vue.directive('permission', permission)


async function init() {
  await hidePageLoading();

  if (isDefaultTheme()) {
    await updateElementTheme(getTheme());
  }
  new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount('#app')

  const resizeLazy = debounce(function () {
    EventBus.$emit(ResizeWindowEventName);
  }, 500)

  window.addEventListener("resize", resizeLazy)
}


const token = getToken()
const sessionID = getSessionID()
const isSessionIdNotEmpty = sessionID !== null && sessionID !== '' && sessionID !== undefined;
const isTokenNotEmpty = token !== null && token !== undefined
if ( isSessionIdNotEmpty || isTokenNotEmpty) {
  if(isTokenNotEmpty) {
    const webToken = parse(token);
    store.commit(`user/${MutationsTypes.SetToken}`, webToken);
  }else {
    store.commit(`user/${MutationsTypes.SetSessionID}`, sessionID);
  }
  // store.dispatch(`user/${ActionsType.SetUserInfo}`)
  //   .catch(() => {
  //     store.commit(`user/${MutationsTypes.Logout}`)
  //   })
  //   .finally(init)
    init()
} else {
  init();
}

/**
 * 隐藏启动动画
 */
async function hidePageLoading() {
  const $pageLoding = document.querySelector('#page-loading-box')
  const startupTime = (window as any).startupTime;
  if (!$pageLoding) {
    return;
  }
  if (!startupTime) {
    return;
  }
  const now = Date.now();

  const yu = now - (window as any).startupTime;

  await new Promise<void>((resolve, reject) => {
    const timeout = 500;

    if (yu >= timeout) {
      resolve()
    } else {
      setTimeout(() => {
        resolve();
      }, timeout - yu)
    }
  });

  $pageLoding.remove();
}
